import firebase from "firebase/app";
import firebaseConfig from "../config/Firebase/firebaseConfig";
import { GroupInvite } from "./types";

const baseOptions = {
  "Content-Type": "application/json",
};

const api_base_url = `https://admin-dot-${firebaseConfig.projectId}.appspot.com`;
const onboard_base_url = `https://onboarding-dot-${firebaseConfig.projectId}.appspot.com`;

export async function createChat(user: firebase.User, name: string) {
  try {
    const token = await user.getIdToken();
    return await fetch(`${api_base_url}/v1/chats`, {
      method: "POST",
      headers: {
        ...baseOptions,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ userID: user.uid, name }),
    });
  } catch (error) {
    return null;
  }
}

export async function onboardGroup(user: firebase.User, groupID: string) {
  try {
    const token = await user.getIdToken();
    return await fetch(`${onboard_base_url}/onboardings/group/${groupID}`, {
      method: "POST",
      headers: {
        ...baseOptions,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({}),
    });
  } catch (error) {
    return null;
  }
}

export async function inviteToGroup(groupID: string, invite: GroupInvite) {
  try {
    const { name, phoneNumber } = invite;
    return await fetch(`${api_base_url}/groups/${groupID}/invites`, {
      ...baseOptions,
      ...{
        method: "POST",
        body: JSON.stringify({
          invites: [{ name, phoneNumber }],
        }),
      },
    });
  } catch (error) {
    console.log("failed to invite to group for user", groupID, error);
    return null;
  }
}

export async function removeFromGroup(groupID: string, userId: string) {
  try {
    return await fetch(`${api_base_url}/groups/${groupID}/members/${userId}`, {
      ...baseOptions,
      ...{
        method: "DELETE",
      },
    });
  } catch (error) {
    console.log("failed to remove from group", groupID, error);
    return null;
  }
}
